export const getPieChartOptions = (chart: ChartBlockAttributes) => {
    return {
        showLabels: Boolean(chart.display.showLabels),
        maxItems: chart.display.limitNumberItems,
        innerRadius: '60%',
    }
}
